/* linkandsync.icon.svg.js */

"use strict";
module.exports = {
    icon: ` 
            <svg width="24" height="24" viewBox="0 1 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_51_11)">
                    <path class="foreground-gl" fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.47 2 11.99 2C17.2013 2 21.4801 5.97844 21.956 11.0565C20.6888 9.78609 18.9362 9 17 9C15.6803 9 14.446 9.36518 13.3924 10H9.66C9.57 10.65 9.5 11.32 9.5 12C9.5 12.68 9.57 13.34 9.66 14H10.2899C10.1013 14.6337 10 15.305 10 16C10 18.4918 11.302 20.6795 13.2627 21.9199C12.846 21.9728 12.4212 22 11.99 22C6.47 22 2 17.52 2 12ZM15.97 8H18.92C17.96 6.35 16.43 5.07 14.59 4.44C15.19 5.55 15.65 6.75 15.97 8ZM13.91 8C13.48 6.57 12.83 5.24 12 4.04C11.17 5.24 10.52 6.57 10.09 8H13.91ZM4 12C4 12.69 4.1 13.36 4.26 14H7.64C7.56 13.34 7.5 12.68 7.5 12C7.5 11.32 7.56 10.66 7.64 10H4.26C4.1 10.64 4 11.31 4 12ZM8.03 16H5.08C6.04 17.66 7.57 18.93 9.41 19.56C8.81 18.45 8.35 17.25 8.03 16ZM5.08 8H8.03C8.35 6.75 8.81 5.55 9.41 4.44C7.57 5.07 6.04 6.34 5.08 8Z" fill="#5D6F80"/>
                    <path class="foreground-gl" d="M12.7857 18.0714H18.2935V15.7143L21.4285 18.8572L18.2935 22V19.6429H12.7857V18.0714Z" fill="#5D6F80"/>
                    <path class="foreground-gl" d="M21.4286 12.8152H15.9207V10.458L12.7857 13.6009L15.9207 16.7437V14.3866H21.4286V12.8152Z" fill="#5D6F80"/>
                </g>
                <defs>
                    <clipPath id="clip0_51_11">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>


         `,
};
